import { render, staticRenderFns } from "./WJModal.vue?vue&type=template&id=1bb63564&scoped=true"
import script from "./WJModal.vue?vue&type=script&lang=js"
export * from "./WJModal.vue?vue&type=script&lang=js"
import style0 from "./WJModal.vue?vue&type=style&index=0&id=1bb63564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb63564",
  null
  
)

export default component.exports